import api from '@/api/inspections';
import store from '@/store/store';

const fetchInspections = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchInspections(criteria.pageIndex, criteria.searchTerm, criteria.orderInfo, criteria.forWorker, criteria.siteId)
    .then((response) => {
      resolve(response);
      store.commit('inspections/storeInspectionList', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchInspection = (context, params) => new Promise(((resolve, reject) => {
  api.fetchInspection(params.id, params.withDeleted)
    .then((response) => {
      resolve(response);
      store.commit('inspections/storeInspection', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const updateInspection = (context, params) => {
  if (params == null || params === undefined) {
    store.commit('inspections/storeUpdatedInspection', null);
  }
  return new Promise(((resolve, reject) => {
    api.updateInspection(params)
      .then((response) => {
        resolve(response);
        store.commit('inspections/storeUpdatedInspection', response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  }));
};

const createInspection = (context, params) => new Promise(((resolve, reject) => {
  api.createInspection(params)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const deleteInspection = (context, id) => new Promise(((resolve, reject) => {
  api.deleteInspection(id)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const updateInspectionStatementResult = (context, criteria) => new Promise(((resolve, reject) => {
  api.updateInspectionStatementResult(criteria.params, criteria.id)
    .then((response) => {
      resolve(response);
      store.commit('inspections/storeUpdatedInspection', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const updateInspectionStatementMemo = (context, criteria) => new Promise(((resolve, reject) => {
  api.updateInspectionStatementMemo(criteria.params, criteria.inspectionStatementId, criteria.id)
    .then((response) => {
      resolve(response);
      store.commit('inspections/storeUpdatedInspection', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const finalizeInspection = (context, criteria) => new Promise(((resolve, reject) => {
  api.finalizeInspection(criteria.id, criteria.inspections_statements_memos, criteria.participantIds)
    .then((response) => {
      resolve(response);
      store.commit('inspections/storeUpdatedInspection', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const removeApproval = (context, criteria) => new Promise(((resolve, reject) => {
  api.removeApproval(criteria.id)
    .then((response) => {
      resolve(response);
      store.commit('inspections/storeUpdatedInspection', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

export default {
  fetchInspections,
  fetchInspection,
  updateInspection,
  createInspection,
  deleteInspection,
  updateInspectionStatementResult,
  updateInspectionStatementMemo,
  finalizeInspection,
  removeApproval,
};




// WEBPACK FOOTER //
// ./src/store/modules/inspections/actions.js